import { Alert, ViewSwitch } from "../components";
import { DevicesGridView, DevicesListView } from ".";
import {
  devicesLoaded,
  getDevices,
  getDevicesFailed,
  getDevicesView,
  getUserDevices,
} from "../redux/devices-slice";
import { useDispatch, useSelector } from "react-redux";
import { REFRESH_INTERVAL } from "../constants/constants";
import styles from "./MyDevicesPage.module.scss";
import { useEffect } from "react";
import { useFormatMessage } from "../i18n";

export function MyDevicesPage() {
  const dispatch = useDispatch();
  const tr = useFormatMessage();
  const devices = useSelector(getDevices);
  const devicesView = useSelector(getDevicesView);
  const devicesLoadingFailed = useSelector(getDevicesFailed);
  const initialLoadSuccessfull = useSelector(devicesLoaded);

  useEffect(() => {
    dispatch(getUserDevices());
  }, [dispatch]);

  useEffect(() => {
    const interval = setInterval(() => {
      dispatch(getUserDevices());
    }, REFRESH_INTERVAL);
    return () => clearInterval(interval);
  }, [dispatch]);

  return (
    <div>
      <ViewSwitch />
      {devicesLoadingFailed && !initialLoadSuccessfull ? (
        <Alert severity="error" className={styles.devicesError}>
          {tr("fail_getting_devices")}
        </Alert>
      ) : (
        <>
          {devicesView === "grid" && <DevicesGridView devices={devices} />}
          {devicesView === "list" && <DevicesListView devices={devices} />}
        </>
      )}
    </div>
  );
}
